import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const OOP_FunctionsWithObjects = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return ( 
    <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Function with Default Arguments & Functions with Objects and Arguments"
      videos={[
        "https://www.youtube.com/embed/fjHz9GPr6qM", // Inline Functions & Default Parameters in C++
        "https://www.youtube.com/embed/w35ObkSRq48", // Pointer to Object | Pass & return Objects in Functions
        "https://www.youtube.com/embed/09SVahE6SDU", // Passing Objects as function arguments in C++
      ]}
      takeaways={[
        { text: "Learn the programming part of this topic and theory with example codes." },
        { text: "Questions won’t be direct; expect only application-based coding questions." },
        { text: "In exams, write the expected output at the end, even if your logic is incorrect. This increases your chances of getting more marks." },
      ]}
      questions={[]} // No specific previous questions provided
      exampleVideos={[]} // No example question videos provided
    />
);
}

export default OOP_FunctionsWithObjects;
